import * as React from 'react'

interface Props {
  variant: string
  content: string
  classes?: string
}

/**
 * Heading Component
 * @param variant - Variation of the headings. Expected values: "H1" | "H2" | "H3" | "H4"
 * @param content - Text of the headings.
 * @param classes (optional) - Tailwindcss classes to customize it.
 */

const Headings = ({ variant, content, classes }: Props) => {
  const LocalVariant = variant.toLowerCase()
  return (
    <>
      {LocalVariant === 'h1' && (
        <h1
          data-testid="headings"
          className={`pb-16 text-h2 lg:text-h1 ${classes ? classes : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        ></h1>
      )}
      {LocalVariant === 'h2' && (
        <h2
          data-testid="headings"
          className={`pb-16 text-h3 lg:text-h2 ${classes ? classes : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        ></h2>
      )}
      {LocalVariant === 'h3' && (
        <h3
          data-testid="headings"
          className={`pb-16 text-2xl lg:text-h3 ${classes ? classes : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        ></h3>
      )}
      {LocalVariant === 'h4' && (
        <h4
          data-testid="headings"
          className={`pb-16 text-lg font-semibold lg:text-h4 ${classes ? classes : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        ></h4>
      )}
    </>
  )
}

export default Headings
